import React from "react";
import { Box, Typography } from "@mui/material";
import { FEATURES, SPECS, specsPulse } from "./specsTheme";

const FeatureIcons = () => (
  <Box
    component="ul"
    sx={{
      listStyle: "none",
      m: 0,
      p: 0,
      display: "grid",
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      justifyItems: "center",
      gap: "clamp(4px, 1.2vw, 28px)",
      position: "relative",
      zIndex: 2,
      width: "100%",
      maxWidth: 720,
      minWidth: 0,
    }}
  >
    {FEATURES.map((feature) => (
      <Box
        component="li"
        key={feature.label}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "clamp(2px, 0.6vh, 8px)",
          minWidth: 0,
          maxWidth: "100%",
          containerType: "inline-size",
        }}
      >
        <Box
          aria-hidden
          sx={{
            width: "clamp(36px, 6.5vh, 64px)",
            height: "clamp(36px, 6.5vh, 64px)",
            borderRadius: "clamp(12px, 2vh, 18px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "clamp(1.05rem, 2.6vh, 1.85rem)",
            lineHeight: 1,
            background: `linear-gradient(145deg, ${feature.accent}33, rgba(0,0,0,0.45))`,
            border: `1px solid ${feature.accent}66`,
            boxShadow: `0 0 22px ${feature.accent}33`,
            animation: `${specsPulse} 3.2s ease-in-out infinite`,
          }}
        >
          {feature.emoji}
        </Box>
        <Typography
          sx={{
            fontFamily: SPECS.fontDisplay,
            fontWeight: 800,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontSize: "clamp(0.48rem, 16cqi, 0.85rem)",
            color: feature.accent,
            textShadow: `0 0 14px ${feature.accent}66`,
            textAlign: "center",
            lineHeight: 1.1,
          }}
        >
          {feature.label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default FeatureIcons;
